import { trackEvent } from '@vp/om-newrelic-tracker';
import {
  createTrackingErrorData,
  createTrackingEventData,
  sanitizeError,
} from './newRelicTrackingUtils';

const FETCH_SUPPORTED_ORDER_ACTIONS = 'FETCH_SUPPORTED_ORDER_ACTIONS';
const FETCH_ANONYMOUS_ORDER = 'FETCH_ANONYMOUS_ORDER';
const FETCH_ORDER_ERROR = 'FETCH_ORDER_ERROR';
const ANONYMOUS_ORDER_TRANSFER_ERROR = 'ANONYMOUS_ORDER_TRANSFER_ERROR';
const ANONYMOUS_ORDER_TRANSFER_REQUESTED = 'ANONYMOUS_ORDER_TRANSFER_REQUESTED';
const ANONYMOUS_ORDER_TRANSFER_SUCCESS = 'ANONYMOUS_ORDER_TRANSFER_SUCCESS';

export const trackGetSupportedOrderActionsError = (
  shopperId: string,
  orderNumber: string
) => {
  const trackingErrorData = createTrackingErrorData(
    FETCH_SUPPORTED_ORDER_ACTIONS,
    {},
    shopperId,
    {
      orderNumber,
    }
  );
  trackEvent(trackingErrorData);
};

/**
 * An error occurred when fetching an order
 */
export const trackFetchOrderError = (err: object, orderId: string) => {
  const error = sanitizeError(err);
  const errorData = createTrackingErrorData(FETCH_ORDER_ERROR, error, '', {
    orderId,
  });
  trackEvent(errorData);
};

/**
 * Report a metric whenever an anonymous order transfer fails
 */
export const trackAnonymousOrderTransferError = (
  err: object,
  additionalData = {}
) => {
  const error = sanitizeError(err);
  const errorData = createTrackingErrorData(
    ANONYMOUS_ORDER_TRANSFER_ERROR,
    error,
    '',
    additionalData
  );
  trackEvent(errorData);
};

/**
 * Report a metric whenever an attempt to transfer an anonymous order is made
 * @param {object} additionalData
 */
export const trackAnonymousOrderTransferRequested = (
  additionalData: object
) => {
  const eventData = createTrackingEventData(
    ANONYMOUS_ORDER_TRANSFER_REQUESTED,
    '',
    additionalData
  );
  trackEvent(eventData);
};

/**
 * Report a metric whenever an attempt to fetch an order from an anonymous session is made
 * @param {object} additionalData
 */
export const trackFetchAnonymousOrderRequested = (additionalData: object) => {
  const eventData = createTrackingEventData(
    FETCH_ANONYMOUS_ORDER,
    '',
    additionalData
  );
  trackEvent(eventData);
};

/**
 * Report a metric whenever an anonymous order transfer succeeds
 * @param {object} additionalData
 */
export const trackAnonymousOrderTransferSuccess = (additionalData: object) => {
  const eventData = createTrackingEventData(
    ANONYMOUS_ORDER_TRANSFER_SUCCESS,
    '',
    additionalData
  );
  trackEvent(eventData);
};
